import decodeTokenJWT from "@/services/office/tokens/decodeToken";
import MultasPagoView from "@/views/Multas/MultasPagoView.vue";
import OwnMultasView from "@/views/Multas/OwnMultasView.vue";
//import MultasView from "@/views/Municipal/multas/MultasView.vue";
//import InspectorView from "@/views/Municipal/multas/InspectorView.vue";
import { createRouter, createWebHistory } from "vue-router";
import EstadisticasView from "@/views/Municipal/Estadisticas/EstadisticasView.vue";
import { hasAccessToRoute } from "./router-utils";
import { pushStep } from "./navigationStack";

const routes = [
  {
    path: "/",
    redirect: { name: "login" },
    meta: {
      noValidate: true,
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login/LoginView.vue"),
    meta: {
      noValidate: true,
      title: "Luque | Ofidi",
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/HomeVecino/HomeVecinoView.vue"),
    meta: {
      requiresAuth: true,
      title: "Luque | Inicio",
    },
  },

  //PARA VISTA DE SUBACTEGORIA
  {
    //SectorTitle se pasa unicamente como prop para header de la vista
    path: "/sector/:sectorTitle/:sectorId",
    name: "sector",
    component: () => import("../views/Tramites/SectorView.vue"),
    meta: { requiresAuth: true },
  },

  // {
  //   path: "/sector/:sectorTitle/:sectorId/:tramiteId",
  //   name: "subCategoria",
  //   component: () => import("../views/Tramites/OpcionesTramitesView.vue"),
  //   meta: { requiresAuth: true },
  // },
  //vista de tramites

  //PASOS  Y REQUISITOS DE CADA TRAMITE
  {
    path: "/requisitos/:formularioTitle/:tramiteId",
    name: "requisitos",
    component: () => import("@/views/Requisitos/RequisitosView.vue"),
    meta: { requiresAuth: true },
  },
  //PRESENTACION DE UN TRAMITE
  {
    path: "/cuestionario/:formularioTitle/:tramiteId",
    name: "formulario",
    component: () => import("@/views/Formulario/FormularioView.vue"),
    meta: { requiresAuth: true },
  },
  // {
  //   //PORTAL TRIBUTARIA
  //   path: "/portal-tributario/pagar-tasas",
  //   name: "portal-tributario-tasas",
  //   component: () => import("../views/PagarTasas/PagarTasasView.vue"),
  //   meta: { requiresAuth: true },
  // },
  {
    //PORTAL TRIBUTARIA
    path: "/portal-tributario/:title/:id",
    name: "portal-tributario",
    component: () =>
      import("../views/PortalTributario/PortalTributarioView.vue"),
    meta: { requiresAuth: true, title: "Luque | Portal Tributario" },
  },
  {
    //PORTAL OBRAS y CATASTRO
    path: "/portal-habilitaciones/:sectorId/:nombreSector/:sectorIdDos/:nombreSectorDos",
    name: "portal-habilitaciones",
    component: () =>
      import("../views/PortalHabilitaciones/PortalHabilitacionesView.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PORTAL TRIBUTARIO TRANSITO
    path: "/portal-transito/:sectorId/:nombreSector/:sectorIdDos/:nombreSectorDos",
    name: "portal-transito",
    component: () => import("../views/PortalTransito/PortalTransitoView.vue"),
    meta: { requiresAuth: true, title: "Luque | Portal de Tránsito" },
  },
  //PERFIL USUARIO
  {
    path: "/micuenta",
    name: "micuenta",
    component: () => import("@/views/PerfilVecino/CuentaView.vue"),
    meta: { requiresAuth: true, title: "Luque | Mi perfil" },
  },
  //HISTORIAL DE TRAMITES
  {
    path: "/tramites",
    name: "tramites",
    component: () =>
      import("@/views/HistorialTramites/HistorialTramitesView.vue"),
    meta: { requiresAuth: true, title: "Luque | Mis trámites" },
  },
  //HISTORIAL DE NOTIFICACIONES
  {
    path: "/notificaciones",
    name: "notificaciones",
    component: () => import("@/views/Comunicaciones/ComunicacionesView.vue"),
    meta: { requiresAuth: true, title: "Luque | Notificaciones" },
  },
  //TURNOS
  {
    path: "/turnos",
    name: "turnos",
    component: () => import("../views/Turnos/TurnosView.vue"),
    meta: { requiresAuth: true, title: "Luque | Turnos" },
  },
  {
    path: "/turnos/nuevo-turno/:tramiteId",
    name: "nuevo-turno",
    component: () => import("../views/Turnos/NuevoTurnoView.vue"),
    meta: { requiresAuth: true },
  },
  //DOCUMENTOS
  {
    path: "/documentos",
    name: "documentos",
    component: () => import("../views/Documentos/DocumentosView.vue"),
    meta: { requiresAuth: true, title: "Luque | Documentos" },
  },
  //REPRESENTACIONES
  {
    path: "/representaciones",
    name: "representaciones",
    component: () =>
      import("../views/Representaciones/RepresentacionesView.vue"),
    meta: { requiresAuth: true, title: "Luque | Representaciones" },
  },
  {
    path: "/representaciones/nueva-representacion",
    name: "nueva-representacion",
    component: () =>
      import("../views/Representaciones/NuevaRepresentacionView.vue"),
    meta: { requiresAuth: true },
  },
  //VISTA PAGO REALIZADO O RECHAZADO
  {
    path: "/pago-resultado",
    name: "pago-resultado",
    component: () => import("@/views/Pago/PagoRespuestaView.vue"),
  },
  // MUNICIPAL
  {
    path: "/home-agentes",
    name: "home-agentes",
    component: () =>
      import("@/views/Municipal/HomeMunicipal/HomeMunicipalView.vue"),
    meta: {
      requiresAuth: true,
      isMunicipal: true,
      home: true,
      title: "Trámites",
      iconLight: "LuqueLogoTramites.svg",
      iconDark: "LuqueLogoTramiteLight.svg",
      badgeResolver: "toDoProcedureCounter",
    },
  },
  {
    path: "/tramites/:id",
    name: "tramite-notification",
    component: () =>
      import("@/views/Municipal/HomeMunicipal/HomeMunicipalView.vue"),
    meta: {
      requiresAuth: true,
      isMunicipal: true,
    },
  },
  {
    path: "/turnero",
    name: "turnero",
    component: () => import("@/views/Municipal/Turnos/TurnosView.vue"),
    meta: {
      requiresAuth: true,
      isMunicipal: true,
      home: true,
      title: "Turnos",
      iconLight: "LuqueLogoTurnos.svg",
      iconDark: "LuqueLogoTurnosLight.svg",
      badgeResolver: "appointmentTodayCount",
    },
  },
  {
    path: "/tareas",
    name: "tareas",
    component: () => import("@/views/Municipal/Tareas/TareasView.vue"),
    meta: {
      requiresAuth: true,
      isMunicipal: true,
      home: true,
      title: "Tareas",
      iconLight: "LuqueLogoTareas.svg",
      iconDark: "LuqueLogoTareasLight.svg",
      allowMobile: true,
      badgeResolver: "toDoTaskCount",
    },
  },
  {
    path: "/tareas/:id",
    name: "tarea-notification",
    component: () => import("@/views/Municipal/Tareas/TareasView.vue"),
    meta: {
      requiresAuth: true,
      isMunicipal: true,
      allowMobile: true,
      badgeResolver: "toDoTaskCount",
    },
  },
  {
    path: "/vecinos",
    name: "vecinos",
    component: () => import("@/views/Municipal/Vecinos/VecinoView.vue"),
    meta: {
      requiresAuth: true,
      isMunicipal: true,
      home: true,
      title: "Vecinos",
      iconLight: "LuqueLogoVecinos.svg",
      iconDark: "LuqueLogoVecinosLight.svg",
    },
  },
  // {
  //   path: "/chat-ia",
  //   name: "chat",
  //   component: () => import("@/views/Municipal/IA/ChatIAView.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     requiredArea: "CHAT",
  //     isMunicipal: true,
  //     home: true,
  //     title: "Chat IA",
  //     icon: "LuqueFiesta.svg",
  //   },
  // },
  {
    path: "/estadisticas",
    name: "estadisticas",
    component: EstadisticasView,
    meta: {
      requiresAuth: true,
      isMunicipal: true,
      isSupervisor: true,
      home: true,
      title: "Estadísticas",
      iconLight: "LuqueLogoEstadisticas.svg",
      iconDark: "LuqueLogoEstadisticasLight.svg",
    },
  },
  {
    path: "/noticias",
    name: "noticias",
    component: () => import("@/views/Municipal/Noticias/NoticiasView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "NOTICIAS",
      isMunicipal: true,
      home: true,
      title: "Noticias",
      iconLight: "LuqueLogoNoticias.svg",
      iconDark: "LuqueLogoNoticiasLight.svg",
    },
  },
  {
    path: "/crear-noticia",
    name: "crear-noticia",
    component: () => import("@/views/Municipal/Noticias/CrearNoticiaView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "NOTICIAS",
      isMunicipal: true,
    },
  },
  {
    path: "/editar-noticia/:id",
    name: "editar-noticia",
    component: () => import("@/views/Municipal/Noticias/CrearNoticiaView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "NOTICIAS",
      isMunicipal: true,
    },
    props: true,
  },
  /*{
    path: "/multas",
    name: "multas",
    component: MultasView,
    meta: {
      requiresAuth: true,
      requiredArea: "MULTAS",
      isMunicipal: true,
      minLevel: 1,
      home: true,
      title: "Multas",
      icon: "LuqueLogoMultas.svg",
    },
  },*/
  {
    path: "/normativas",
    name: "normativas",
    component: () => import("@/views/Municipal/Normativas/NormativasView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "DIGESTO",
      isMunicipal: true,
      home: true,
      title: "Digesto",
      iconLight: "LuqueNormativas.svg",
      iconDark: "LuqueNormativasLight.svg",
    },
  },
  {
    path: "/crear-normativas",
    name: "crear-normativas",
    component: () =>
      import("@/views/Municipal/Normativas/CrearNormativasView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "DIGESTO",
      isMunicipal: true,
    },
  },
  {
    path: "/editar-normativas/:id",
    name: "editar-normativas",
    component: () =>
      import("@/views/Municipal/Normativas/CrearNormativasView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "DIGESTO",
      isMunicipal: true,
    },
    props: true,
  },
  {
    path: "/alojamiento",
    name: "alojamiento",
    component: () => import("@/views/Municipal/Alquileres/AlquileresView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "ALOJAMIENTO",
      isMunicipal: true,
      home: true,
      title: "Alojamiento",
      iconLight: "LuqueFiesta.svg",
      iconDark: "LuqueFiestaLight.svg",
    },
  },
  {
    path: "/cargar-alojamiento",
    name: "cargar-alojamiento",
    component: () =>
      import("@/views/Municipal/Alquileres/CrearAlquileresView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "ALOJAMIENTO",
      isMunicipal: true,
    },
  },
  {
    path: "/editar-alojamiento/:id",
    name: "editar-alojamiento",
    component: () =>
      import("@/views/Municipal/Alquileres/CrearAlquileresView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "ALOJAMIENTO",
      isMunicipal: true,
    },
  },
  {
    path: "/oficios",
    name: "oficios",
    component: () => import("@/views/Municipal/Oficio/OficiosView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "OFICIO",
      isMunicipal: true,
      home: true,
      title: "Oficios",
      iconLight: "LuqueOficios.svg",
      iconDark: "LuqueOficiosLight.svg",
    },
  },
  {
    path: "/cargar-oficios",
    name: "cargar-oficios",
    component: () => import("@/views/Municipal/Oficio/CrearOficiosView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "OFICIO",
      isMunicipal: true,
    },
  },
  {
    path: "/editar-oficios/:id",
    name: "editar-oficios",
    component: () => import("@/views/Municipal/Oficio/CrearOficiosView.vue"),
    meta: {
      requiresAuth: true,
      requiredArea: "OFICIO",
      isMunicipal: true,
    },
  },
  /*{
    path: "/inspectores",
    name: "inspectores",
    component: InspectorView,
    meta: {
      requiresAuth: true,
      requiredArea: "INSPECTORES",
      isMunicipal: true,
      special: true,
      minLevel: 1,
      home: true,
      title: "Inspectores",
      icon: "LuqueLogoMultas.svg",
      allowMobile: true,
    },
  },*/
  {
    path: "/mis-multas",
    name: "ver-multas",
    component: OwnMultasView,
    meta: { requiresAuth: true },
  },
  //VECINO PAGO
  {
    path: "/pago/multas",
    name: "pago-multas",
    component: MultasPagoView,
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "not-found",
  //   component: () => import("@/views/Municipal/Error/NotFoundView.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  pushStep(to.fullPath);
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("token");

  if (!token || typeof token !== "string" || !token.includes(".")) {
    if (to.meta.requiresAuth) {
      const cookieBase =
        "path=/; domain=.ofidi.com.ar; secure; SameSite=None; max-age=600";

      document.cookie = `rutaPush=${encodeURIComponent(to.fullPath)}; ${cookieBase}`;

      const partes = to.fullPath.split("/");
      const idExtraido = partes[partes.length - 1].split("?")[0];
      if (idExtraido && !isNaN(idExtraido)) {
        document.cookie = `pushId=${idExtraido}; ${cookieBase}`;
      }

      const esDeepLink =
        to.query.redirectPush ||
        to.fullPath.includes("/tramites/") ||
        to.fullPath.includes("/tareas/");

      return next({
        name: "login",
        ...(esDeepLink && {
          query: { redirectPush: to.fullPath },
        }),
      });
    }

    return next();
  }

  const user = decodeTokenJWT(token);

  if (!user) {
    return next({ name: "login" });
  }

  if (!hasAccessToRoute(user, to)) {
    return next(from.name ? { name: from.name } : { name: "login" });
  }

  next();
});

router.beforeEach((to, from, next) => {
  const defaultTitle = "Luque | Municipalidad";
  document.title = to.meta.title || defaultTitle;
  next();
});

router.afterEach((to) => {
  const theme = document.querySelector("meta[name='theme-color']");

  if (!theme) return;

  if (to.path === "/login") {
    theme.setAttribute("content", "#ffffff");
  } else {
    theme.setAttribute("content", "rgba(158, 158, 158, 1)");
  }
});

export default router;
